



document.addEventListener("DOMContentLoaded", () => {
  class VideoCarrousel extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.initSwiper();
    }
    initSwiper() {
      const videoImageSlider = this.querySelector('.video__story-slide');
      if (!videoImageSlider) return;

      const desktopSlides = parseInt(videoImageSlider.dataset.desktop) || 3;
      const mobileSlides = parseFloat(videoImageSlider.dataset.mobile) || 1;
      const desktopSpace = parseInt(videoImageSlider.dataset.space) || 15;
      const mobileSpace = parseInt(videoImageSlider.dataset.space / 2) || 7;
      new Swiper(videoImageSlider, {
        slidesPerView: mobileSlides,
        spaceBetween: mobileSpace,
        navigation: {
          nextEl: this.querySelector('.swiper-button-next.video-next-arrow'),
          prevEl: this.querySelector('.swiper-button-prev.video-previous-arrow'),
        },
        breakpoints: {
          990: {
            slidesPerView: desktopSlides,
            spaceBetween: desktopSpace,
          },
        },
      });
    }
  }
  customElements.define('video-carrousel', VideoCarrousel);
  /*---button--*/
  let videoPopupSwiper = null;
  const buttonPopup = document.querySelectorAll('.mediabutton');
  buttonPopup.forEach((buttonInner, index) => {
    buttonInner.addEventListener('click', () => {
      if (videoPopupSwiper) {
        videoPopupSwiper.slideTo(index);
      }
    });
  });
  /*--swiper---*/
  function slidePopup(slideIndex) {
    const videoPopupSlider = document.querySelector('.slider__video-popup');
    if (!videoPopupSlider) return;
    videoPopupSwiper = new Swiper(videoPopupSlider, {
      slidesPerView: 1,
      watchSlidesProgress: true,
      spaceBetween: 0,
      loop: true,
      effect: "fade",
      autoplay: {
        delay: 60000,
      },
      pagination: {
        el: ".swiper-pagination",
        renderBullet: (index, className) =>
          `<div class="${className}"><div class="swiper-pagination-progress"></div></div>`,
        clickable: true,
      },
      navigation: {
        nextEl: document.querySelector('.swiper-button-next.popup-next-arrow'),
        prevEl: document.querySelector('.swiper-button-prev.popup-previous-arrow'),
      },
      on: {
        autoplayTimeLeft: (swiper, time, progress) => {
          const currentSlide = document.querySelectorAll('.slider__video-popup .swiper-slide')[swiper.activeIndex];
          const currentBullet = document.querySelectorAll('.slider__video-popup .swiper-pagination-progress')[swiper.realIndex];
          const fullTime = parseInt(currentSlide.dataset.swiperAutoplay);
          const percentage = `${Math.min(Math.max(parseFloat(((fullTime - time) * 100 / fullTime).toFixed(1)), 0), 100)}%`;
          currentBullet.style.width = percentage;
        },
        transitionEnd(swiper) {
          let allBullets = document.querySelectorAll('.slider__video-popup .swiper-pagination-progress');
          let bulletsBefore = Array.prototype.slice.call(allBullets, 0, swiper.realIndex);
          let bulletsAfter = Array.prototype.slice.call(allBullets, swiper.realIndex, allBullets.length);
          if (bulletsBefore.length) {
            bulletsBefore.forEach(function(bullet) {
              bullet.style.width = '100%';
            });
          }            
          if (bulletsAfter.length) {
            bulletsAfter.forEach(function(bullet) {
              bullet.style.width = '0%';
            });
          }         
        },
      }
    });
    videoPopupSwiper.on("slideChange", function() {
      const current_index = this.realIndex + 1;
      const videoSlider = document.querySelectorAll('.video-popup-slide');
      videoSlider.forEach((slide) => {
          const video = slide.querySelector('video');
          if (video) {
              const dataIndex = parseInt(slide.getAttribute('data-index'));
              if (current_index === dataIndex) {
                  playVid(video); // Play video immediately
              } else {
                  pauseVid(video);
                  video.currentTime = 0; // Reset video time
              }
          }
      });
    });
  }

  if (!customElements.get("video-modal-dialog")) {
    customElements.define("video-modal-dialog",
      class ProductModalDialog extends customElements.get("modal-dialog") {
        constructor() {
          super();
          // swiper hide slide touch
            var startY, endY;
            const swipeSizeguides = document.querySelectorAll('.video-popup-modal');
            swipeSizeguides.forEach(function (swipeSizeguide) {
              swipeSizeguide.addEventListener('touchstart', function(e) {
                startY = e.touches[0].clientY;
              });
              swipeSizeguide.addEventListener('touchend', function(e) {
                endY = e.changedTouches[0].clientY;
                var distanceY = endY - startY;
                if (distanceY > 100) {
                  console.log('swipe down');
                  this.hide();
                }
              });
            });
        }
        connectedCallback() {
          super.connectedCallback();
        }
        show(opener) {
          this.openedBy = opener;
          document.body.classList.add('overflow-hidden');
          this.setAttribute('open', '');
          updateVideoSources();  // Ensure videos are updated
          slidePopup();
        }
        hide() {
          super.hide();
          if (videoPopupSwiper) {
            videoPopupSwiper.destroy(true, true);
            videoPopupSwiper = null;
            const slides = document.querySelectorAll('.video-popup-slide');
            slides.forEach((slide) => {
              const video = slide.querySelector('video');
              if (video) {
                const videoSource = video.getAttribute("data-src");
                video.src = '';
                video.muted = true;
              }
            });
          }
        }

      }
    );
  }
  
  // Helper functions to safely play and pause videos
  async function playVid(video) {
    try {
      if (!video.paused && !video.ended) {
        return;
      }
      const playPromise = video.play();
      if (playPromise !== undefined) {
        await playPromise;        
      }
    } catch (error) {
      console.error("Error playing video:", error);
    }
  }
  function pauseVid(video) {
    if (!video.paused) {
      video.pause();
    }
  }
  function updateVideoSources() {
    const slides = document.querySelectorAll('.video-popup-slide');
    slides.forEach((slide) => {
        const video = slide.querySelector('video');
        if (video) {
            const videoSource = video.getAttribute("data-src");
            if (videoSource) {
                video.src = videoSource;
                video.preload = "auto"; // Preload the video
                video.muted = false;  
                video.load(); // Load the video to buffer it
            } else {
                video.src = '';
                video.muted = true;
            }
        }
    });
  }
});
